import { render, staticRenderFns } from "./yuekelslb.vue?vue&type=template&id=53ea6d86&scoped=true"
var script = {}
import style0 from "./yuekelslb.vue?vue&type=style&index=0&id=53ea6d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea6d86",
  null
  
)

export default component.exports